import React, { useState, useRef } from 'react';
import { FlatList } from 'react-native';

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import ManualRefresh from '@vfgroup-oneplatform/foundation/Components/ManualRefresh';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import { getThemeImages } from '../../../Themes';
import { InProgressOrdersCard } from '../../Components';

import ManageYourOrdersProps from './ManageYourOrders.context';
import styles from './ManageYourOrders.styles';

const ManageYourOrders = props => {
  const { onClose, orders, onRefresh, lastUpdateTime, orderAccountName } = props;

  const headerRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);

  const theme = useTheme();
  const images = getThemeImages(theme.name);

  const configureHeaderTabs = {
    activeTab: activeTab,
    setActiveTab: index => setActiveTab(index),
    tabs: [
      { index: 0, tab_key: 'my_orders_inprogress' },
      { index: 1, tab_key: 'my_orders_pastorders' },
    ],
  };

  const vfScreenStringProps = {
    contentContainerStyle: styles.contentContainer,
    withSubHeader: true,
    subHeaderTitle: 'my_orders_manage_your_orders',
    subHeaderTitleStyle: styles.subHeaderTitle,
    subHeaderSubTitle: ContentManager.translate('my_orders_number_of_orders_inprogress', [
      orders.length,
    ]),
    subHeaderMaxHeight: 110,
    subHeaderSubTitleStyle: styles.subHeaderSubTitle,
    subHeaderDescription: ContentManager.translate('logout_subtitle', [orderAccountName]),
    renderDescriptionInfo: renderDescriptionInfo,
  };

  function renderDescriptionInfo() {
    return (
      <ManualRefresh
        containerStyle={styles.manualRefresh}
        onRefresh={onRefresh}
        images={images}
        lastUpdateTime={lastUpdateTime}
      />
    );
  }

  function renderInprogressTab(isActive) {
    return (
      isActive && (
        <FlatList
          data={orders}
          keyExtractor={item => item.id}
          renderItem={({ item }) => <InProgressOrdersCard order={item} />}
        />
      )
    );
  }

  return (
    <VFScreen
      ref={headerRef}
      title="my_orders_title"
      onClose={onClose}
      configureHeaderTabs={configureHeaderTabs}
      {...vfScreenStringProps}
    >
      <ManageYourOrdersProps.Provider value={props}>
        {renderInprogressTab(activeTab === 0)}
      </ManageYourOrdersProps.Provider>
    </VFScreen>
  );
};

ManageYourOrders.defaultProps = {
  onOrderItemPress: () => {},
};

ManageYourOrders.propTypes = {
  onClose: PropTypes.func.isRequired,
  onRefresh: PropTypes.func,
  orders: PropTypes.array.isRequired,
  lastUpdateTime: PropTypes.any,
  orderAccountName: PropTypes.string.isRequired,
  onOrderItemPress: PropTypes.func,
};

export default ManageYourOrders;
